import createStateContext from 'utils/createStateContext'

const [useSharedState, SharedStateProvider] = createStateContext({})

export { useSharedState, SharedStateProvider }
